export enum SourceTypeEnum {
	UNKNOWN = "Unknown",
	LK = "LK",
	KZ = "KZ"
}
